import axios from 'axios';

// Opens a shuttle mission instance for approval (backend calculates all paths)
export default async function openShuttleMissionForApproval(baseUrl, missionPayload){
  try {
    // Backend expects a plain JSON body, not nested or stringified
    const res = await axios.post(`${baseUrl}/admin/openShuttleMissionForApproval`, missionPayload);
    return res.data || res;
  } catch(e){
    // Propagate rich error details so callers can display server messages
    const resp = e?.response;
    if (resp && resp.data) {
      // Ensure a predictable shape
      return {
        success: resp.data.success === undefined ? false : resp.data.success,
        error: resp.data.error || resp.data.message || e.message,
        resultCode: resp.data.resultCode,
        step: resp.data.step,
        errorReason: resp.data.errorReason || resp.data.reason,
        status: resp.status,
        statusText: resp.statusText,
        data: resp.data
      };
    }
    return {
      success: false,
      error: e?.message || 'Request failed',
      status: resp?.status,
      statusText: resp?.statusText
    };
  }
}
